<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const mounted = ref(false);
const props = defineProps({
  id: Number,
  reviews: Array,
});

let swiper = null;

onMounted(() => {
  nextTick(() => {
    swiper = document.querySelector(".swiper-reviews-" + props.id)?.swiper;
    mounted.value = true;
  });
});
</script>

<template>
  <div class="tile relative w-full h-full pt-100p md:pt-0">
    <div class="tile__inner absolute inset-[10px] group overflow-hidden">
      <Swiper
        v-if="mounted"
        class="swiper-reviews"
        :class="'swiper-reviews-' + id"
        :height="500"
        :slidesPerView="1"
        :spaceBetween="0"
        :loop="true"
        :modules="[Pagination]"
        :pagination="{
          clickable: true,
        }"
      >
        <SwiperSlide
          v-for="(review, index) in reviews"
          :key="'slide-1' + index"
          :id="'slide-' + index"
          class="relative bg-center bg-cover bg-no-repeat text-2xl lg:text-4x p-xs md:p-md lg:-p-lg xl:p-xl"
        >
          <div class="w-full py-xl">
            <div class="w-30px lg:w-[45px] mb-md">
              <img aria-label="Citaat" src="/img/quotes.png" />
            </div>
            <div
              v-if="review.text"
              v-html="review.text"
              class="text-white text-base"
            ></div>
            <div class="flex flex-row mt-md lg:mt-lg items-center">
              <div
                v-if="review.image"
                class="w-60px lg:w-90px flex-shrink-0 mr-md"
              >
                <picture v-if="review.image">
                  <source
                    v-if="review.image?.url?.webp"
                    :srcset="review.image?.url?.webp"
                    type="image/jpeg"
                  />
                  <source
                    v-if="review.image?.url?.jpg"
                    :srcset="review.image?.url?.jpg"
                    type="image/webp"
                  />
                  <img
                    class="rounded-full"
                    :src="review.image?.url?.jpg"
                    :alt="review.image?.alt"
                    :title="review.image?.title"
                    aria-label="Citaat"
                  />
                </picture>
              </div>
              <div class="flex-grow">
                <div v-if="review.name" class="text-yellow">
                  {{ review.name }}
                </div>
                <div v-if="review.function" class="text-xs text-white">
                  {{ review.function }}
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<style>
.swiper-reviews {
  @apply absolute inset-0 w-full h-full;

  .swiper-wrapper {
    @apply items-center;
  }

  .swiper-pagination {
    @apply absolute bottom-0 flex justify-end pr-sm pb-xxs lg:pb-sm;

    .swiper-pagination-bullet {
      @apply bg-white w-16px h-16px lg:w-20px lg:h-20px rounded-full opacity-100 mx-xxs;

      &-active {
        @apply !bg-red;
      }
    }
  }

  .swiper-slide {
    @apply flex items-center;
  }
}
</style>
